import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams, useHistory } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

import user from "../../static/images/user.png";
import comentario_empresa from "../../static/images/comentario_empresa.png";
import { Url } from "../../utils/Url/Url";

function VistaVacante() {
  const params = useParams();
  let history = useHistory();
  const [data, setData] = useState("");

  useEffect(() => {
    if (params.id === undefined) {
      toast.error("Vacante no disponible", {
        duration: 5000,
      });
      setTimeout(function () {
        history.push("/company/Home");
      }, 6000);
    }
    const getData = async () => {
      const res = await axios.get("/company-vacant/" + params.id);
      setData(res.data);
    };
    getData();
  }, []);

  const h = {
    textAlign: "center",
  };

  return (
    <div className="vacantes profile">
      {/* <Header></Header> */}
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="bordered-box">
              <div className="bordered-box__container">
                <div className="job-header">
                  <div className="job-header__top">
                    <div className="job-header__name">
                      <div className="job-header__name-logo">
                        <img
                          src={
                            data.companyVacant?.companyProfileId
                              .profileImagePath
                          }
                          alt=""
                          style={{ maxWidth: "92px", maxHeight: "87px" }}
                        ></img>
                      </div>
                      <div className="job-header__name-title">
                        {data.companyVacant?.cargo ?? ""}
                      </div>
                      <div className="job-header__name-company">
                        {/* {state.lugar} */}
                      </div>
                      <div className="job-header__name-location">Managua</div>
                    </div>
                    <div className="job-header__top-buttons">
                      <div className="job-header__apply">
                        <button
                          className="btn btn--gradient"
                          data-bs-toggle="modal"
                          data-bs-target="#kr-modal"
                          data-title="Experiencia"
                          // onClick={aplicarVacante}
                          //onClick={sendMail}
                        >
                          Editar
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="job-header__middle">
                    <div className="job-header__middle-col">
                      <ul>
                        <li>
                          <strong>Publicado:</strong>{" "}
                          {data.companyVacant?.fechaPublicacion ?? ""}
                        </li>
                        <li>
                          <strong>Tipo:</strong> Remoto / Presencial
                        </li>
                        <li>
                          <strong>Experiencia:</strong>{" "}
                          {data.companyVacant?.nivelExperienciaEmpleoId.name ??
                            ""}
                        </li>
                      </ul>
                    </div>
                    <div className="job-header__middle-col">
                      <ul>
                        <li>
                          <strong>Aptitudes:</strong> 2 / 10
                        </li>
                      </ul>
                      <div className="job-header__middle-aptitude">
                        Liderazgo - Comunicación - Innovacions
                      </div>
                    </div>
                    <div className="job-header__middle-col">
                      <ul>
                        <li className="view-icon">
                          <strong>Visualizaciones:</strong> 0{" "}
                          <a
                            href="#"
                            onClick={() => {
                              let host = window.location.hostname;
                              //in the case host having a port, include it in the url
                              if (window.location.port) {
                                host = host + ":" + window.location.port;
                              }
                              let protocol =
                                window.location.protocol === "https:"
                                  ? "https"
                                  : "http";
                              let finalUrl = `${protocol}://${host}/compartir/vacante/${params.id}`;
                              let Title = `Vacante: ${data.companyVacant?.cargo} - ${data.companyVacant?.companyProfileId.name}`;
                              let body =
                                "Revisa esta vacante que encontre en Krezco, la red social de desarrollo profesional";
                              navigator.share({
                                title: Title,
                                url: finalUrl,
                                text: body,
                              });
                            }}
                            className="mx-3"
                          >
                            <i
                              className="fa fa-share-alt"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </li>
                        <li className="carpet-icon">
                          <strong>Postulaciones:</strong> 0{" "}
                        </li>
                      </ul>
                    </div>
                    <div className="job-header__middle-col">
                      <ul className="toolset"></ul>
                    </div>
                  </div>

                  {/* <div className="job-header__bottom">
                    <div className="job-header__bottom-left">
                      <ul className="job-header__bottom-button">
                        <li>
                          <a href="" className="btn btn--purple">
                            Pide una Recomendación
                          </a>
                        </li>
                        <li>
                          <a href="" className="btn btn--purple">
                            Referir a contacto
                          </a>
                        </li>
                        <li>
                          <a href="" className="btn btn--purple">
                            Pregúntanos
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="job-header__bottom-right">
                      <div className="job-header__bottom-salary">
                        Salario: {data.salario}
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row vacancy__content">
          <div className="col-12 col-md-5">
            <div className="vacancy__sidebar bordered-box">
              <div className="bordered-box__header">
                <div className="bordered-box__header-title">Información</div>
              </div>
              <div className="vacancy__sidebar-content">
                <ul>
                  <li>
                    <strong>Sitio Web:</strong>
                    <a
                      href={Url(data.companyVacant?.companyProfileId.webSite)}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {Url(data.companyVacant?.companyProfileId.webSite)}
                    </a>
                  </li>
                  <li>
                    <strong>Sector:</strong>
                    {data.companyVacant?.companyProfileId.sectorId.name ?? ""}
                  </li>
                  <li>
                    <strong>Ubicación:</strong>
                    {data.companyVacant?.companyProfileId.ubication ?? ""}
                  </li>
                  <li>
                    <strong>Año de Fundación:</strong>
                    {data.companyVacant?.companyProfileId.fundation ?? ""}
                  </li>
                  <li>
                    <strong>Empleados:</strong>
                    {data.companyVacant?.companyProfileId.employes ?? ""}
                  </li>
                </ul>
                <Link
                  to={{
                    pathname: "/user/PerfilEmpresa",
                    state: {
                      empresa: data.companyVacant?.companyProfileId.name,
                      logo: data.companyVacant?.companyProfileId
                        .profileImagePath,
                      profileId:
                        data.companyVacant?.companyProfileId.companyProfileId,
                    },
                  }}
                  className="btn btn--gradient btn--small"
                >
                  Ver Perfil
                </Link>
                <ul className="social-media">
                  {data.linkTwitter != "" ? (
                    <li>
                      <a href={Url(data.linkTwitter) ?? ""}>
                        <i className="fab fa-twitter-square"></i>
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  {data.linkFacebook != "" ? (
                    <li>
                      <a href={Url(data.linkFacebook) ?? ""}>
                        <i className="fab fa-facebook-square"></i>
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  {data.linkInstagram != "" ? (
                    <li>
                      <a href={Url(data.linkInstagram) ?? ""}>
                        <i className="fab fa-instagram-square"></i>
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-7">
            <div className="vacancy__description bordered-box">
              <div className="bordered-box__header">
                <div className="bordered-box__header-title">
                  Descripción del Puesto
                </div>

                <div className="content">
                  <p>{data.companyVacant?.acercaVacante}</p>
                </div>
              </div>
              <div className="bordered-box__body">
                {/* <div className="bordered-box__header-title">
                   Responsabilidades 
                </div>*/}

                <div className="content">
                  <p></p>

                  {/* <div className="title">Requisitos, Habilidades/Aptitudes</div> */}

                  <p></p>

                  {/* <ul>
                    <li>lor sit amet, con</li>
                    <li>erat, sed dia Stet</li>
                    <li>clita kasd gubergre</li>
                    <li>lor sit amet, con</li>
                    <li>lor sit amet, con</li>
                    <li>erat, sed dia Stet</li>
                    <li>clita kasd gubergre</li>
                    <li>lor sit amet, con</li>
                  </ul>*/}

                  <div className="title">Beneficios</div>

                  <p>{data.companyVacant?.beneficios}</p>

                  <div className="title">Comentarios</div>

                  <p>{data.companyVacant?.comentarios}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12">
          {/*<div className="comentarios bordered-box">
            <div className="preguntas">Preguntas de Candidatos</div>
            <div className="contenido">
              <div className="imagen-de-perfil">
                <img src={user} alt="Profile Icon"></img>
              </div>
              <div className="dialogo">
                <span className="nombre">Maria Rodríguez</span>
                <span>Asistente de comunicación en Bac Credomatic</span>{" "}
                <span className="hora">Hace 2 Dias</span>
                <div className="caja-comentario">
                  <p>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy eirmod tempor invidunt ut labore et dolore magna
                    aliquyam erat, sed diam voluptua. At vero eos et accusam et
                    justo duo dolores et ea rebum. Stet clita kasd gubergren, no
                    sea takimata sanc.
                  </p>
                </div>
              </div>
            </div>
            <div className="respuesta">
              <span>Hace 2 Dias</span>
              <div className="comentario-empresa">
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et
                  justo duo dolores et ea rebum. Stet clita kasd gubergren, no
                  sea takimata sanc.
                </p>
              </div>
              <img src={comentario_empresa} alt="Profile Icon"></img>
            </div>

            <div className="preguntanos">
              <div className="title">Pregúntanos</div>

              <div className="justificar-contenido">
                <div className="imagen-de-perfil">
                  <img src={user} alt="Profile Icon"></img>
                </div>

                <div className="area-de-texto">
                  <textarea defaultValue="Escribe tu Pregunta"></textarea>
                  <button className="btn btn--gradient btn--small">
                    Ver Perfil
                  </button>
                </div>
              </div>
            </div>
          </div>*/}
        </div>
      </div>

      {/* <div className="bottom-content mt-2">
        <div className="container">
          <div className="button">
            <a href="#" className="btn btn--gradient">
              Más Empleos de esta Empresa
            </a>
            <button
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#kr-modal"
              data-title="Experiencia"
              className="btn btn--gradient"
              // onClick={aplicarVacante}
            >
              Aplicar
            </button>
            <a href="#" className="btn btn--gradient">
              Guardar
            </a>
          </div>
        </div>
      </div> */}

      <div
        id="kr-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={h}>
              <h3 htmlFor="cargo">
                Tu aplicación ha sido enviada exitosamente
              </h3>
            </div>
            {/* <div className="modal-footer">
              <button
                type="button"
                data-bs-dismiss="modal"
                //onClick={aplicarVacante}
                className="btn btn--small btn--purple"
                disabled={sending}
              >
                Agregar
              </button>
            </div>*/}
          </div>
        </div>
      </div>
    </div>
  );
}
export default VistaVacante;
